import http from '@/http'
const URL = '/admin/follow-up-rules'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveItem = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const deleteRule = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (id) => http.put(URL + `/${id}/status`)

// Helpers para buscar dados de referência
export const getForms = async (params) => {
  return http.get('/admin/forms', { params })
}

export const getStatuses = async () => {
  return http.get('/admin/settings/status-select')
}

export const getGroups = async () => {
  return http.get('/admin/settings/groups')
}

export const getTags = async () => {
  return http.get('/admin/tags')
}

export const getEmailTemplates = async () => {
  return http.get('/admin/settings/email')
}

export const getRefStatuses = async () => {
  return http.get('/admin/settings/refstatus')
}

export const getThankYouPages = async () => {
  return http.get('/admin/thank-you-pages/active')
}

export const getWaTemplates = async () => {
  return http.get('/admin/settings/wa/templates')
}

export default {
  list,
  show,
  saveItem,
  deleteRule,
  changeStatus,
  getForms,
  getStatuses,
  getRefStatuses,
  getGroups,
  getTags,
  getEmailTemplates,
  getThankYouPages,
  getWaTemplates
}
